let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jwSno")).then(() => parcelRequire('3KUzn'));